import classNames from 'classnames';
import React from 'react';

const GameRow = ({ word = '', isGuess, empty, input = ['', '', '', '', ''] }) => {
  const alreadyYellowShowedLetters = [];

  return (
    <div className='flex w-full justify-center'>
      {new Array(5).fill(' ').map((_, i) => {
        const letter = input[i];
        const isThisLetterGuessedInCorrectPosition = letter === word[i];

        let shouldShowThisLetterYellow = false;
        const isThisLetterExistsInTheWord = word.includes(letter);

        if (isThisLetterExistsInTheWord && !isThisLetterGuessedInCorrectPosition) {
          //
          const howManyTimesThisLetterInCorrectPositionGuessed = input.filter((letterOfInput, indexOfInnerLoop) => {
            if (word[indexOfInnerLoop] === letterOfInput && letterOfInput === letter) return true;
            return false;
          }).length;

          const howManyTimesLetterExistsInWord = word.split('').filter((x) => x === letter).length;
          const howManyTimesThisLetterYellowShowedBefore = alreadyYellowShowedLetters.filter((x) => x === letter).length;

          shouldShowThisLetterYellow =
            howManyTimesLetterExistsInWord - howManyTimesThisLetterInCorrectPositionGuessed > howManyTimesThisLetterYellowShowedBefore;

          if (shouldShowThisLetterYellow) {
            alreadyYellowShowedLetters.push(letter);
          }
        }

        const className = classNames(
          'h-8 md:h-12 text-xl w-[calc(17%)] border-2 border-gray-600 text-white m-0.5 flex justify-center items-center font-semibold uppercase',
          {
            'bg-green-600 border-green-600': isThisLetterGuessedInCorrectPosition && isGuess,
            'bg-yellow-500 border-yellow-500': !isThisLetterGuessedInCorrectPosition && shouldShowThisLetterYellow && isGuess,
            'bg-gray-600 ': !isThisLetterGuessedInCorrectPosition && !shouldShowThisLetterYellow && isGuess,
          }
        );

        return (
          <div key={i} className={className}>
            <span className='b'>{letter}</span>
          </div>
        );
      })}
    </div>
  );
};

export default GameRow;
